module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


	var learnMoreText = localize({
		'ru': 'Узнать больше',
		'en': 'Learn more'
	});
	dates.forEach(function(item, i) {
;
__p += '\n		<div class="news__item">\n			<div class="news__labels">\n				<time class="news__date" pubdate datetime="' +
((__t = (item.PUB_TIME_ATR)) == null ? '' : __t) +
'">\n					' +
((__t = (item.ACTIVE_FROM)) == null ? '' : __t) +
'\n				</time>\n			</div>\n			<div class="news__img" style="background-image: url(\'' +
((__t = (item.PREVIEW_PICTURE.src)) == null ? '' : __t) +
'\');"></div>\n			<span class="news__heading">\n				' +
((__t = (item.NAME)) == null ? '' : __t) +
'\n			</span>\n			<div class="news__text">\n				' +
((__t = (item.PREVIEW_TEXT)) == null ? '' : __t) +
'\n			</div>\n			<a href="' +
((__t = (item.DETAIL_PAGE_URL)) == null ? '' : __t) +
'" class="btn btn--corner">' +
((__t = (learnMoreText)) == null ? '' : __t) +
'</a>\n		</div>\n';

	})
;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./frontend/components/news/news.ejs
// module id = 200
// module chunks = 0